import React from "react";

import "./CustomerButton.scss";
import { NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useCustomer } from "../../auth/useCustomer";
import CatalogContext from "../../contexts/CatalogContext";
import { useBookmarkContext } from "../../hooks/useBookmarkContext";
import { SidebarContentType, useSidebarContext } from "../../hooks/useSidebarContext";

const CustomerAssignerModal = React.lazy(() => import("./CustomerAssignerModal"));


export default function CustomerButton() {
	const CustomerContext = useCustomer();
	const [customer, setCustomer] = React.useState(null);
	const SidebarContext = useSidebarContext();
	const [catalog] = React.useContext(CatalogContext);
	const BookmarkContext = useBookmarkContext();
	const [assignCustomerMode, setAssignCustomerMode] = React.useState(undefined);

	React.useEffect(() => {
		if (CustomerContext.isAllowed(catalog)) {
			const storedCustomer = CustomerContext.getStoredCustomer();
			if (storedCustomer) {
				CustomerContext.fromHandle({ handle: storedCustomer.handle })
					.then(customer => CustomerContext.setCustomer(customer));
			}
		}

		return () => { }
	}, []);

	React.useEffect(() => {
		setCustomer(CustomerContext.customer);
	}, [CustomerContext.customer?.handle])

	if (!CustomerContext.isAllowed(catalog)) return;

	const info_click = async () => {
		SidebarContext.open(SidebarContentType.Customer);
	}

	const signOut_click = async () => {
		await unsetCustomer();
	}

	const unsetCustomer = async () => {
		setCustomer(undefined);
		await CustomerContext.unassignCustomer(BookmarkContext);
	}

	const startCustomerFind = async () => {
		setAssignCustomerMode("find");
	}

	const startAddNewCustomer = () => {
		setAssignCustomerMode("add");
	}

	return (
		<NavDropdown
			className={["user-nav", CustomerContext.customer && "customer-signed-in"].filter(c => c).join(" ")}
			title={
				<OverlayTrigger placement="bottom" overlay={
					<Tooltip className="_boss tooltip">Customer</Tooltip>
				}>
					<button data-component="CustomerButton" className="iconable"></button>
				</OverlayTrigger>
			}
		>
			{!!customer && (
				<>
					<NavDropdown.Header>{customer.first_name} {customer.last_name}</NavDropdown.Header>
					<NavDropdown.Divider />
					<NavDropdown.Item onClick={info_click}>
						Info
					</NavDropdown.Item>
					<NavDropdown.Divider />
				</>
			)}
			<NavDropdown.Item onClick={startCustomerFind}>
				{customer ? (<>Switch</>) : (<>Open</>)} Customer
			</NavDropdown.Item>
			<NavDropdown.Item onClick={startAddNewCustomer}>
				Add Customer
			</NavDropdown.Item>
			{!!customer && (
				<>
					<NavDropdown.Divider />
					<NavDropdown.Item onClick={signOut_click}>
						Close Customer
					</NavDropdown.Item>
				</>
			)}


			{assignCustomerMode != null && (
				<>
					<React.Suspense fallback={<></>}>
						<CustomerAssignerModal
							mode={assignCustomerMode}
							onClose={() => setAssignCustomerMode(undefined)}
						/>
					</React.Suspense>

					<NavDropdown.Divider />
				</>
			)}
		</NavDropdown>
	);
}
